import { Link, useNavigate } from "react-router-dom";
import { usePaystackPayment } from "react-paystack";
import { useContext, useState } from "react";
import { Context } from "../context/MainContext";
import Loading from "./Loading";
import { paymentApproved } from "../api/usersApi";
import { toast } from "react-toastify";
import payStackImg from "../assets/images/paystack.png";
import { clearCart, updateCart } from "../context/Action";

const PayWithPaystack = ({ loading, proceedPayment, handleInitPayment }) => {
  const [loadingMain, setLoadingMain] = useState(false);
  const { dispatch } = useContext(Context);

  const formattingOption = {
    style: "currency",
    currency: "NGN",
    minimumFractionDigits: 2,
  };

  const { orderId } = useContext(Context);
  const navigate = useNavigate();
  console.log(orderId?.reference, orderId?.email, orderId?.amount);

  const config = {
    reference: orderId?.reference,
    email: orderId?.email,
    amount: orderId?.amount, // Paystack amount is in kobo (multiply by 100)
    publicKey: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
    currency: "NGN",
  };

  // ✅ Keep onSuccess synchronous
  const onSuccess = (reference) => {
    console.log({ reference, tes: "dhjdsd" });

    handlePaymentSuccess(reference);
  };

  // Move async logic here
  const handlePaymentSuccess = async (reference) => {
    setLoadingMain(true);
    try {
      const data = {
        firstName: orderId?.firstName,
        orderId: orderId?.orderId,
        paymentId: reference?.reference || orderId?.reference,
        amount: orderId?.amount
          ? (orderId?.amount / 100).toLocaleString("en-NG", formattingOption)
          : "",
        email: orderId?.email,
      };

      const res = await paymentApproved(
        reference?.reference || orderId?.reference,
        data,
      );

      if (!res.data?.success) {
        toast.error("Payment verification failed, please contact support");
        return;
      }

      toast.success("Payment successful, Order Processing");
      dispatch(clearCart());
      navigate("/account?tab=orders");
    } catch (err) {
      const message =
        (err.response && err.response.data && err.response.data.message) ||
        err.message ||
        err.toString();
      toast.error(message);
    } finally {
      setLoadingMain(false);
    }
  };

  const onClose = () => {
    toast.info("Payment cancelled");
  };

  const initializePayment = usePaystackPayment(config);

  return (
    <div className="paypalPayment">
      <div className="paypalPayment__header">
        <h4>Paystack</h4>
        <img src={payStackImg} alt="Paystack" />
        <a href="https://paystack.com" target="_blank" rel="noreferrer">
          What is Paystack?
        </a>
      </div>

      <div className="paypalPayment__info">
        Pay via Paystack; you can pay with your debit/credit card, bank
        transfer, or USSD.
      </div>

      <div className="paypalPayment__info2">
        Your personal data will be used to process your order, support your
        experience throughout this website, and for other purposes described in
        our <Link to="/privacy-policy">privacy policy</Link>.
      </div>

      <div className="paypalPayment__btnCon">
        {proceedPayment ? (
          <button
            className="paypalPayment__btnCon__btn"
            onClick={() => initializePayment({ onSuccess, onClose })}
          >
            {loadingMain ? <Loading button={true} /> : "Pay with Paystack"}
          </button>
        ) : (
          <button
            className="paypalPayment__btnCon__btn alt"
            onClick={handleInitPayment}
          >
            {loading ? <Loading button={true} /> : "Initiate Payment"}
          </button>
        )}
      </div>
    </div>
  );
};

export default PayWithPaystack;
